import React from 'react';

/**
 * ActiveWordsPanel - Display words currently being practiced
 *
 * Shows vocabulary words that the agent has retrieved for the current session.
 */
const ActiveWordsPanel = ({ words }) => {
  if (!words || words.length === 0) return null;

  /**
   * Get badge color based on learning level
   */
  const getLevelColor = (level) => {
    const colors = {
      hard: 'bg-red-100 text-red-800 border-red-200',
      learning: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      mastered: 'bg-green-100 text-green-800 border-green-200'
    };
    return colors[level] || colors.learning;
  };

  /**
   * Get level icon
   */
  const getLevelIcon = (level) => {
    const icons = {
      hard: '🔴',
      learning: '🟡',
      mastered: '🟢'
    };
    return icons[level] || '🟡';
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-xs font-medium text-gray-500 whitespace-nowrap">
        Practice words:
      </span>
      {words.map((word, index) => (
        <span
          key={word.wordId || index}
          className={`
            inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs
            border ${getLevelColor(word.learningLevel)}
          `}
          title={word.translation?.text ? `${word.word} - ${word.translation.text}` : word.word}
        >
          <span className="text-[10px]">{getLevelIcon(word.learningLevel)}</span>
          <span className="font-medium">{word.word}</span>
          {word.translation?.text && (
            <span className="text-gray-500">({word.translation.text})</span>
          )}
        </span>
      ))}
    </div>
  );
};

export default ActiveWordsPanel;
